var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVideoCam = function SvgVideoCam(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e8e5fe;}.cls-2{fill:#8075f2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "budicon-video-cam"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.5,17H1.5a.5.5,0,0,1-.5-.5v2a.5.5,0,0,0,.5.5h15a.5.5,0,0,0,.5-.5v-2A.5.5,0,0,1,16.5,17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18 15.427 23 18.998 23 16.998 18 13.427 18 15.427"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.5,10h-3a.5.5,0,0,0,0,1h3a.5.5,0,0,0,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.9964,7a.9875.9875,0,0,0-.5776.188L18,10.3442V8.5A1.5,1.5,0,0,0,16.5,7H1.5A1.5,1.5,0,0,0,0,8.5v10A1.5,1.5,0,0,0,1.5,20h15A1.5,1.5,0,0,0,18,18.5V16.6558l4.4188,3.1563a.9875.9875,0,0,0,.5776.188A1.001,1.001,0,0,0,24,18.998V8.0015A1.0009,1.0009,0,0,0,22.9964,7ZM17,18.5a.5.5,0,0,1-.5.5H1.5a.5.5,0,0,1-.5-.5V8.5A.5.5,0,0,1,1.5,8h15a.5.5,0,0,1,.5.5v10Zm6,.498-5-3.5713V11.5732l5-3.5708Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVideoCam);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/video-cam.ffe25e411374563e67797c90136527f9.svg";